import type { SVGProps } from 'react';
const SvgNavWalletFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    height={24}
    fill="none"
    width={24}
    {...props}
  >
    <path
      d="M5 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.412A1.93 1.93 0 0 1 5 3h14q.824 0 1.413.587Q21 4.176 21 5h-8q-1.775 0-2.887 1.112T9 9v6q0 1.775 1.113 2.887T13 19h8q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zm8-4q-.825 0-1.412-.587A1.93 1.93 0 0 1 11 15V9q0-.825.588-1.412A1.93 1.93 0 0 1 13 7h7q.824 0 1.413.588Q22 8.175 22 9v6q0 .824-.587 1.413A1.93 1.93 0 0 1 20 17zm3-3.5q.65 0 1.075-.425T17.5 12t-.425-1.075T16 10.5t-1.075.425T14.5 12t.425 1.075T16 13.5"
      fill="currentColor"
    />
  </svg>
);
export default SvgNavWalletFilled;
